import React, { useContext } from "react";
import { useEffect } from "react";
import * as FaIcons from "react-icons/fa";
import RegistrationContext from "../../../context/registration/registrationContext";
import ProgressButtons from "../ProgressButtons";
import SubFormButtons from "../SubFormButtons";
import findBrand from "../../findBrand";
import educationLevels from "../../../data/educationLevels";
import relationshipList from "../../../data/relationshipList";
import phoneTypes from "../../../data/phoneTypes";
import { brandDomains, fetchBrands } from "../../brand";


const R3ParentInformation = () => {
  const registrationContext = useContext(RegistrationContext);
  const {
    subFormLevels,
    onFormDataChange,
    pass: { parentInformation },
    // pgPrimaryPhone,
    // pgPrimaryPhoneType,
    formData: {
      pgHighestLevelOfEducation,
      firstName,
      pgFirstName,
      pgLastName,
      pgRelationshipToStudent,
      pgPrimaryEmail,
      pgPrimaryPhone,
      pgPrimaryPhoneType,
      liveWithPg,
    },
  } = registrationContext;

  useEffect(() => {
    const loadBrands = async () => {
      await fetchBrands();
    };

    loadBrands();
  }, []);

  const brand_holston = brandDomains.brand_holston?.name;
  const brand_pbia = brandDomains.brand_pbia?.name;

  const handleChange = (e) => {
    const value = e.target.value;
    e.target.value =
      value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    onFormDataChange(e);
  };

  const validateEmail = (email) => {
    const reg =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const re =
      /^[^.#]+([a-zA-Z[0-9.!$%&'*+/=?^_`{|}~-]+)[^-#\.]@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))+$/;
    ///^(+(\.[^<>()[a-zA-Z[0-9\]\\.,;:\s@"]+)*)|(".+")@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))+$/;

    return (
      re.test(String(email).toLowerCase()) &&
      reg.test(String(email).toLowerCase())
    );
  };

  const validatePhone1 = (number) => {
    const re = /^\d{3}(\))?(-|\s)?\d{3}(-|\s)\d{4}$/;
    return re.test(String(number).toLowerCase());
  };

  const formatPhoneNumber1 = (evt) => {
    const regex = /^\+?[0-9-]+$/;
    if (evt.target.value === "" || regex.test(evt.target.value)) {
      var aVal = evt.target.value;
      aVal = aVal
        .replace(/\\D/g, "")
        .replace(/ /g, "")
        .replace(/\-/g, "")
        .replace(/\(/g, "")
        .replace(/\)/g, "");
      if (aVal.length >= 10 && aVal.charAt(0) == "1")
        aVal = aVal.replace("-", "").replace("-", "");
      if (aVal.length > 0) {
        if (aVal.length > 8) {
          aVal =
            aVal.substring(0, 3) +
            "-" +
            aVal.substring(3, 6) +
            "-" +
            aVal.substring(6, 10);
          // window.alert(aVal);
          evt.target.value = aVal;
        } else if (aVal.length == 7) {
          aVal = aVal.substring(0, 3) + "-" + aVal.substring(3, 7);
          evt.target.value = aVal;
        }
      }
      onFormDataChange(evt);
    }
    // }
  };

  const parentsInfo =
    pgFirstName !== "" &&
    pgLastName !== "" &&
    pgRelationshipToStudent !== "" &&
    pgPrimaryEmail !== "" &&
    validateEmail(pgPrimaryEmail) &&
    pgPrimaryPhone !== "" &&
    validatePhone1(pgPrimaryPhone) &&
    pgPrimaryPhoneType !== "" &&
    liveWithPg !== "";

  const parentsInfo2 =
    pgHighestLevelOfEducation !== "" &&
    pgFirstName !== "" &&
    pgLastName !== "" &&
    pgRelationshipToStudent !== "" &&
    pgPrimaryEmail !== "" &&
    validateEmail(pgPrimaryEmail) &&
    pgPrimaryPhone !== "" &&
    validatePhone1(pgPrimaryPhone) &&
    pgPrimaryPhoneType !== "";

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const message = "Are you sure you want to leave?";
      event.returnValue = message;
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  //findBrand is used to check whether holston forms or other forms
  if (findBrand(brand_holston) === true || findBrand(brand_pbia)===true ) {
    return (
      <>
        <div className="sub-form">
          <h2 className="">
            Parent 1 Information <span>(3/11)</span>
            <hr />
          </h2>
          <div className="item">
            <div className="asterisk-group">
              <h3>
                What is {firstName === "" ? "the Student" : firstName}'s Parent
                1/Guardian’s Highest Level of Education?
              </h3>
            </div>
            <select
              name="pgHighestLevelOfEducation"
              value={pgHighestLevelOfEducation}
              onChange={(e) => onFormDataChange(e)}
            >
              <option value="">Please Select </option>
              {educationLevels.map((item) => {
                return <option value={item}>{item}</option>;
              })}
            </select>
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>
                What is Parent
                1/Guardian’s Relationship to{" "}
                {firstName === "" ? "the Student" : firstName}?{" "}
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <select
              name="pgRelationshipToStudent"
              value={pgRelationshipToStudent}
              onChange={(e) => onFormDataChange(e)}
              style={{
                border: parentInformation
                  ? "2px solid #ccc"
                  : pgRelationshipToStudent !== ""
                  ? "2px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <option value="">Please Select </option>
              {relationshipList.map((item) => {
                return <option value={item}>{item}</option>;
              })}
            </select>
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>
                What is {firstName === "" ? "the Student" : firstName}'s Parent
                1/Guardian’s First Name?
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="text"
              maxLength="50"
              name="pgFirstName"
              onChange={(e) =>  onFormDataChange(e)}
              value={pgFirstName}
              style={{
                border: parentInformation
                  ? "2px solid #ccc"
                  : pgFirstName !== ""
                  ? "2px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            />
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>
                What is {firstName === "" ? "the Student" : firstName}'s Parent
                1/Guardian’s Last Name?
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="text"
              maxLength="50"
              name="pgLastName"
              onChange={(e) =>  onFormDataChange(e)}
              value={pgLastName}
              style={{
                border: parentInformation
                  ? "2px solid #ccc"
                  : pgLastName !== ""
                  ? "2px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            />
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>
                What is {firstName === "" ? "the Student" : firstName}'s Parent
                1/Guardian's Primary Phone Number?
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="text"
              max="12"
              placeholder="XXX-XXX-XXXX"
              name="pgPrimaryPhone"
              value={pgPrimaryPhone}
              onChange={(e) => formatPhoneNumber1(e)}
              style={{
                border: parentInformation
                  ? "2px solid #ccc;"
                  : pgPrimaryPhone !== ""
                  ? "2px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            />
            {pgPrimaryPhone !== "" && !validatePhone1(pgPrimaryPhone) && (
              <p className="validEmail">
                Please provide a valid phone number in the following format
                XXX-XXX-XXXX
              </p>
            )}
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>
                What is {firstName === "" ? "the Student" : firstName}'s Parent
                1/Guardian's Primary Phone Type?
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <select
              name="pgPrimaryPhoneType"
              value={pgPrimaryPhoneType}
              onChange={(e) => onFormDataChange(e)}
              style={{
                border: parentInformation
                  ? "2px solid #ccc"
                  : pgPrimaryPhoneType !== ""
                  ? "2px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <option value="">Please Select </option>
              {phoneTypes.map((item) => {
                return <option value={item}>{item}</option>;
              })}
            </select>
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>
                What is {firstName === "" ? "the Student" : firstName}'s Parent
                1/Guardian’s Email?
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="email"
              name="pgPrimaryEmail"
              value={pgPrimaryEmail}
              onChange={(e) => onFormDataChange(e)}
              style={{
                border: parentInformation
                  ? "2px solid #ccc;"
                  : pgPrimaryEmail !== ""
                  ? "2px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            />
            {pgPrimaryEmail !== "" && !validateEmail(pgPrimaryEmail) && (
              <p className="validEmail">Please provide a valid email address</p>
            )}
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>
                Does {firstName === "" ? "the Student" : firstName} Live With
                Parent 1?
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <div
              className="flex-check-container"
              style={{
                border: parentInformation
                  ? "1px solid #ccc;"
                  : liveWithPg !== ""
                  ? "1px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <label className="check-container">
                Yes
                <input
                  type="radio"
                  value="yes"
                  checked={liveWithPg["yes"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="liveWithPg"
                />
                <span className="styled-checkmark"></span>
              </label>
              <label className="check-container">
                No
                <input
                  type="radio"
                  value="no"
                  checked={liveWithPg["no"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="liveWithPg"
                />
                <span className="styled-checkmark"></span>
              </label>
            </div>
          </div>
        </div>
        <div className="group">{subFormLevels.parentInformation === 0}</div>
        <ProgressButtons validation={parentsInfo} name="parentInformation" />
      </>
    );
  } else {
    return (
      <>
        <div className="sub-form">
          <h2 className="">
            Parent Information <span>(2/15)</span>
            <hr />
          </h2>
          <div className="item">
            <div className="asterisk-group">
              <h3>What Is the Parent/Guardian’s Highest Level of Education?</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <select
              name="pgHighestLevelOfEducation"
              value={pgHighestLevelOfEducation}
              onChange={(e) => onFormDataChange(e)}
              style={{
                border: parentInformation
                  ? "2px solid #ccc"
                  : pgHighestLevelOfEducation !== ""
                  ? "2px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <option value="">Please Select </option>
              {educationLevels.map((item) => {
                return <option value={item}>{item}</option>;
              })}
            </select>
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>
                What Is the Parent/Guardian’s Relationship to{" "}
                {firstName === "" ? "the Student" : firstName}?{" "}
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <select
              name="pgRelationshipToStudent"
              value={pgRelationshipToStudent}
              onChange={(e) => onFormDataChange(e)}
              style={{
                border: parentInformation
                  ? "2px solid #ccc"
                  : pgRelationshipToStudent !== ""
                  ? "2px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <option value="">Please Select </option>
              {relationshipList.map((item) => {
                return <option value={item}>{item}</option>;
              })}
            </select>
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>What Is the Parent/Guardian’s First Name?</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="text"
              name="pgFirstName"
              maxLength="50"
              onChange={(e) =>  onFormDataChange(e)}
              value={pgFirstName}
              style={{
                border: parentInformation
                  ? "2px solid #ccc"
                  : pgFirstName !== ""
                  ? "2px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            />
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>What Is the Parent/Guardian’s Last Name?</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="text"
              name="pgLastName"
              maxLength="50"
              onChange={(e) => onFormDataChange(e)}
              value={pgLastName}
              style={{
                border: parentInformation
                  ? "2px solid #ccc"
                  : pgLastName !== ""
                  ? "2px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            />
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>What Is the Parent/Guardian’s Email?</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="email"
              name="pgPrimaryEmail"
              value={pgPrimaryEmail}
              onChange={(e) => onFormDataChange(e)}
              style={{
                border: parentInformation
                  ? "2px solid #ccc;"
                  : pgPrimaryEmail !== ""
                  ? "2px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            />
            {pgPrimaryEmail !== "" && !validateEmail(pgPrimaryEmail) && (
              <p className="validEmail">Please provide a valid email address</p>
            )}
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>What Is the Parent/Guardian's Primary Phone Number?</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="text"
              max="12"
              placeholder="XXX-XXX-XXXX"
              name="pgPrimaryPhone"
              value={pgPrimaryPhone}
              onChange={(e) => formatPhoneNumber1(e)}
              style={{
                border: parentInformation
                  ? "2px solid #ccc;"
                  : pgPrimaryPhone !== ""
                  ? "2px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            />
            {pgPrimaryPhone !== "" && !validatePhone1(pgPrimaryPhone) && (
              <p className="validEmail">
                Please provide a valid phone number in the following format
                XXX-XXX-XXXX
              </p>
            )}
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>What Is the Parent/Guardian's Primary Phone Type?</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <select
              name="pgPrimaryPhoneType"
              value={pgPrimaryPhoneType}
              onChange={(e) => onFormDataChange(e)}
              style={{
                border: parentInformation
                  ? "2px solid #ccc"
                  : pgPrimaryPhoneType !== ""
                  ? "2px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <option value="">Please Select </option>
              {phoneTypes.map((item) => {
                return <option value={item}>{item}</option>;
              })}
            </select>
          </div>
        </div>
        <div className="group">{subFormLevels.parentInformation === 0}</div>
        <ProgressButtons validation={parentsInfo2} name="parentInformation" />
      </>
    );
  }
};
export default R3ParentInformation;
